import { useState } from 'react';
import { HEADER_HEIGHT, useMiniChatShallowStore } from '@frontend/mini-chat-store';
import { breakpoints, useMatchMedia } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';
import { Button } from '@frontend/design-system';
import { useSelectedFaxShallowStore } from '../../../stores/selected-fax-store';
import { PageScroller } from '../../document-previewer/page-scroller';

export const ThreadViewBody = () => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageScrollMultiplier, setPageScrollMultiplier] = useState<number | undefined>(0);

  const { chats, rolledUp } = useMiniChatShallowStore('chats', 'rolledUp');
  const isMobileMiniChats = useMatchMedia({ maxWidth: breakpoints.xsmall.max });
  const showBottomPadding = !!chats.length && !rolledUp && !isMobileMiniChats;

  const { selectedFax } = useSelectedFaxShallowStore('selectedFax');

  const totalPages = selectedFax.pages ?? 1;

  return (
    <>
      <div
        css={{
          overflow: 'hidden',
          backgroundColor: theme.colors.neutral10,
        }}
      >
        <PageScroller
          mediaIds={selectedFax.thumbnailIds ?? []}
          pageScrollMultiplier={pageScrollMultiplier}
          setPageScrollMultiplier={setPageScrollMultiplier}
          setCurrentPage={setCurrentPage}
          locationId={selectedFax.locationId}
        />
      </div>
      <div
        css={{
          display: 'flex',
          gap: theme.spacing(2),
          alignItems: 'center',
          justifyContent: 'flex-end',
          padding: theme.spacing(2),
          borderTop: `1px solid ${theme.colors.neutral20}`,
          paddingBottom: showBottomPadding
            ? Number(theme.spacing(2).replace('px', '')) + HEADER_HEIGHT
            : theme.spacing(2),
          transition: 'padding-bottom 300ms ease-in-out',
        }}
      >
        <div
          css={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Button
            label='Page Back'
            iconName='caret-left'
            onClick={() => {
              if (currentPage > 1) {
                setPageScrollMultiplier(currentPage - 2);
                setCurrentPage(currentPage - 1);
              }
            }}
            disabled={currentPage === 1}
            variant='secondary'
          />
          <span
            css={{
              padding: `${theme.spacing(0, 2)}`,
            }}
          >{`${currentPage}/${totalPages}`}</span>
          <Button
            label='Page Forward'
            iconName='caret-right'
            onClick={() => {
              if (currentPage < totalPages) {
                setPageScrollMultiplier(currentPage);
                setCurrentPage(currentPage + 1);
              }
            }}
            disabled={currentPage === totalPages}
            variant='secondary'
          />
        </div>
      </div>
    </>
  );
};
